import gql from 'graphql-tag';

export default gql`
mutation updatePreferredPayment($id: String!){
  updatePreferredPayment(id: $id) {
    id
  }
}
`;
